module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt_jp_m.fd8bc9057b067e04ce12486fcf909433.png";